import styled from '@emotion/styled';
import Chip from '@mui/material/Chip';

export const DashboardDataChip = styled(Chip)(() => ({
  fontSize: '1rem',
  fontWeight: 'bold',
  height: '2em',
  color: 'white',
}));
